import * as Actions from './actions';
import {initialState} from '../store/initialState';
import { ContactlessOutlined } from '@material-ui/icons';

export const CleaningPlaceReducer = (state = initialState.cleaningPlace, action) => {
    switch (action.type) {
        case Actions.FETCH_CLEANING_PLACES:
        return {
                ...state,
                cleaningList: action.payload
            };
        default:
            return state;
    }
}